type Meridiem = 'a.m.' | 'p.m.';

const shortMonths = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
];

//
// Formats a date for display with a short month.
// For example: Jan 1, 2024
//
export function formatDate(dateStr: string | Date): string {
  let d: Date;
  
  // test to see if it's just a date in form: YYYY-MM-DD
  if (typeof dateStr === 'string' && dateStr.length === 10) {
    d = new Date(`${dateStr}T00:00:00.000-05:00`);
  } else if (dateStr instanceof Date) {
    d = dateStr;
  } else {
    d = new Date(dateStr);
  }

  return `${shortMonths[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
}

export function formatTime(dateTimeStr: string | Date): string {
  const d = new Date(dateTimeStr);
  let h = d.getHours();
  const m = d.getMinutes();
  let mStr;
  let ampm: Meridiem;

  if (h > 12) {
    h -= 12;
    ampm = 'p.m.';
  } else if (h === 12) {
    ampm = 'p.m.';
  } else {
    ampm = 'a.m.';
    if (h === 0) h = 12;
  }

  if (m < 10)
    mStr = '0' + m;
  else
    mStr = '' + m;

  return `${h}:${mStr} ${ampm}`;
}

export function formatDateTime(dateTimeStr: string | Date): string {
  return formatDate(dateTimeStr) + ' – ' + formatTime(dateTimeStr);
}
